module.exports = __webpack_public_path__ + "img/message_send.aa89a0eb.svg";